import { useTheme } from '../store/theme';

export function ThemeToggleCustom() {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle-wrapper">
      <label className="theme-switch">
        <input 
          type="checkbox" 
          checked={theme === 'dark'}
          onChange={toggleTheme}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
        />
        <span className="slider" />
      </label>
    </div>
  );
}